<template>
  <div class="review-stars">
    <img src="/static/img/icon_star_full.png" alt="star" v-for="star in starRateFloor" class="review-stars__full">
    <img src="/static/img/icon_star_half.png" alt="star_half" v-if="isStarHalf" class="review-stars__half">
    <img src="/static/img/icon_star_vacant.png" alt="star" v-for="star in vacantStar" class="review-stars__full">
  </div>
</template>

<script>
  export default {
    props: ["rate"],
    data() {
      return {
        starRateFloor: 0,
        isStarHalf: false,
        vacantStar: 0,
      }
    },
    created() {
      this.calculationStars(this.rate);
    },
    watch: {
      rate() {
        this.calculationStars(this.rate);
      }
    },
    methods: {
      calculationStars(rateNumber) {
        const starRate = rateNumber;
        const starRateFloor = Math.floor(starRate);
        let vacantStar = 5 - starRateFloor;
        let isStarHalf = false;
        if ((starRate - starRateFloor) > 0) {
          isStarHalf = true;
          vacantStar -= 1;
        }
        this.starRateFloor = starRateFloor;
        this.isStarHalf = isStarHalf;
        this.vacantStar = vacantStar;
      }
    }
  }
</script>

<style>
  .review-stars__full {
    margin: 0 2px 0 0;
  }
  .star-half {
    margin-left: -2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/smallParts/Star.vue